// Start Rails and necessary modules
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
Rails.start()
window.Rails = Rails; 

Turbolinks.start()
ActiveStorage.start()

import "channels";
import "custom/subscriptions";
import "custom/trix-autolinks";
import "custom/trix-editor-overrides";

import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";

import "froala-editor/css/plugins/char_counter.min.css";
import "froala-editor/css/plugins/code_view.min.css";
import "froala-editor/css/plugins/colors.min.css";
import "froala-editor/css/plugins/image.min.css";
import "froala-editor/css/plugins/fullscreen.min.css";
import "froala-editor/css/plugins/image_manager.min.css";
import "froala-editor/css/third_party/image_tui.min.css";
import "froala-editor/css/plugins/table.min.css";
import "froala-editor/css/plugins/draggable.min.css";
import "froala-editor/css/third_party/embedly.min.css";
import "froala-editor/css/themes/dark.min.css";


// Import other dependencies
import flatpickr from "flatpickr"
import "controllers"
import "active_editing_manager"

// Trix setup
import Trix from 'trix'
require("trix")
require("@rails/actiontext")
Trix.config.attachments.preview.caption.name = false
Trix.config.attachments.preview.caption.size = false

// SlimSelect setup
import SlimSelect from 'slim-select'


document.addEventListener("ajax:beforeSend", function (event) {
  const element = event.target

  // Only trigger for "Update from process"
  if (!element?.dataset?.showProcessLoading) return

  const flash = document.getElementById("global-flash-container")
  if (!flash) return

  const message = flash.dataset.updatingFromProcess || "Updating from process…"

  flash.insertAdjacentHTML(
    "afterbegin",
    `
      <div class="flash-message loading">
        <span class="spinner"></span>
        ${message}
      </div>
    `
  )
})

// REMOVE ONLY loading state (NOT success/error flash)
document.addEventListener("ajax:complete", function () {
  const loading = document.querySelector(
    "#global-flash-container .flash-message.loading"
  )
  if (loading) loading.remove()
})
